import { BillingInterval, Currency } from '../../../commonTypes/client.types';
import { IMenuItem } from '../../Common';
import { IAddressDtoForm } from '../clientFormSchema';

export const isAddressTouched = (address: IAddressDtoForm) => {
    return address !== undefined && (address.city || address.country.value || address.streetline1 || address.state);
};

export const mappedCurrency: IMenuItem[] = Object.entries(Currency).map(e => ({
    label: e[1],
    value: e[1],
}));

export const mappedBillingInterval: IMenuItem[] = Object.entries(BillingInterval).map(e => ({
    label: e[1],
    value: e[1],
}));
